import { mediaUrl } from "@/lib/api";

/** 5.1 #1: one row of square photo chips for cards that hold several products. The first is preselected. */
export default function TypeChips({ chips, value, onChange }) {
    if (!chips || chips.length < 2) return null;
    return (
        <div className="-mx-3 overflow-x-auto px-3 pb-1" data-testid="type-chips">
            <div className="flex w-max gap-2">
                {chips.map((c) => {
                    const on = c.id === value;
                    return (
                        <button key={c.id} type="button" onClick={() => onChange(c.id)} aria-pressed={on}
                            className={`flex w-[104px] shrink-0 flex-col border ${on ? "border-2 border-accent-brand" : "border-ink"}`} data-testid={`type-chip-${c.id}`}>
                            <span className="block aspect-square w-full overflow-hidden border-b border-line bg-page">
                                {c.image && <img src={mediaUrl(c.image)} alt="" loading="lazy" className="h-full w-full object-cover" />}
                            </span>
                            <span className={`block min-h-[44px] px-1 py-1 text-center text-[14px] leading-tight ${on ? "font-semibold" : ""}`}>{c.label}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
